import Basisdaten from "./Basisdaten/Basisdaten.vue";

export default {
  Basisdaten,
};
